<template>
    <div>
        <div class='five-nav flex-start'>
            <!-- <div v-for="(item,index) in content" class="nav-buttom"  @click="goGoodsList(item.url.name,item.url.query.cate_id)">
                <img :src='item.pic_url'>
                <p>{{item.title}}</p>
            </div> -->
            <div v-for="i in 9" :key="i" class="nav-buttom">
                <img src="../../assets/images/pic-homepage-active1.png" alt="" srcset="">
                <p>赛事活动</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NavButton",
        components: {},
        props: {
            content: {
                type: Array,
                default: [],
            },
        },

        data: function () {
            return {}
        },

        methods: {
            goGoodsList(url,cate_id) {
                this.$router.push({
                    path: '/'+url,
                    query: {
                        cate_id: cate_id
                    }
                })
            }
        },

        filters: {}

    };
</script>

<style scoped>
    .five-nav {
        background: #fff;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 6.6rem;
        margin: 0 auto;
    }

    .five-nav > div {
        width: 2.1rem;height: 2.1rem;margin-top:8px ;border-radius: 10px;position: relative;

    }
    .nav-buttom p{
        position:absolute;
       width:112px; 
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    bottom: 12px;
    z-index: 2;
    text-align: center;
    }
    .five-nav img {
         
        width: 2.1rem;
    }
    /* .nav-buttom{width: 2rem;background: red;} */
</style>


// WEBPACK FOOTER //
// navButton.vue?0bf9bf85